import { InvoiceLineItemBase } from "@common/types/invoice";
import { isInvoiceItemLine } from "@common/helpers/lineItems";
import { NativeInvoiceLineCodingByLineId } from "./nativeInvoiceFormTypes";

export function buildNativeInvoiceLineCodingByLineId(
    lines: readonly InvoiceLineItemBase[] | undefined,
): NativeInvoiceLineCodingByLineId | undefined {
    // Synthetic kind: "tax"/"discount"/"deposit" split rows are not revisable
    // item lines — only kind: "item" rows carry the Class + Accrual/Receivables
    // coding this map feeds into the revision drawer.
    const itemLines = lines?.filter(isInvoiceItemLine);
    if (!itemLines?.length) {
        return undefined;
    }
    return Object.fromEntries(
        itemLines.map((line) => [
            line.sourceId,
            {
                classIds: (line.classAssignments ?? []).map(
                    (assignment) => assignment.classId,
                ),
                accrualAccountId: line.accountId ?? null,
                receivablesAccountId: line.accountsReceivableId ?? null,
            },
        ]),
    );
}
